import { RiEditBoxFill } from "react-icons/ri";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import { usePopUpsStore } from "../../../store/PopUpStore";
import Selected from "../../Inputs/Selected";
import Table, { TableOperation } from "../../Table";
import Title from "../../Title/Title";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import PopUpDelete from "../../PopUps/PopUpDelete (1)";
import Pagination from "../../pagination/Pagination (1)";
import { useDelete, useFetch, useFilter, usePOST } from "../../../ApiS";
import MainButton from "../../Buttons/MainButton";
import Input from "../../Inputs/Input";
import { useEffect, useRef, useState } from "react";
import Add from "../../Buttons/Add";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { AxiosError } from "axios";
import Loader from "../../Loader";

interface Exam {
  id: string | number;
  student_id: number | string;
  mark: string | number;
  written_mark: string | number;
  curriculum_id?: string | number;
  semester_id?: string | number;
}

interface Error {
  id?: string[];
  student_id?: string[];
  mark?: string[];
  written_mark?: string[];
  curriculum_id?: string[];
  semester_id?: string[];
}

const Exam_Lists: React.FC = () => {
  const { setPopUpDelete, popUpDelete } = usePopUpsStore();

  const [Popup, setPopup] = useState(0);

  const [errors, setErrors] = useState<Error>({});

  const [Id, setId] = useState<number>();
  const [selectedAcademic, setSelectedAcademic] = useState<number | null>(null);

  const {
    searchParams,
    handlePageClick,
    handleParamDelete,
    handleParamsClick,
    handleParamsDeleteAll,
  } = useFilter();

  const openEditPopupAcademic = (idInfo?: number) => {
    setSelectedAcademic(idInfo!);
    setId(idInfo);
    setPopup(2);
  };
  const closePopupAcademic = () => {
    setPopup(0);
    setSelectedAcademic(null);
    setId(null!);
  };

  const onError = (error: AxiosError<{ errors: Error; message: string }>) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };

  const { id } = useParams();

  const semester_id = searchParams.get("semester_id")
  const curriculum_id =  searchParams.get("curriculum_id")

  const { data, isLoading,refetch } = useFetch(
    `admin/student-marks?semester_id=${semester_id}&curriculum_id=${curriculum_id}`,
    `admin/student-marks`
  );

 useEffect(() => { refetch() }, [semester_id , curriculum_id])

  const { data: Edit, isLoading: EditLoading } = useFetch(
    `admin/student-marks/${Id}`,
    `admin/student-marks/${Id}`,
    Id ? true : false
  );

  const { deleteItem } = useDelete(
    () => {},
    () => {}
  );

  const { data: student } = useFetch("admin/students", "admin/students");

  const { data: semesters } = useFetch("admin/semesters", "admin/semesters");

  const { data: curriculums } = useFetch(
    "admin/curriculums",
    "admin/curriculums"
  );

  const {
    handleChangeInput,
    handleChangeSelect,
    formData,
    setFormData,
    handleSubmit,
    mutation,
  } = usePOST(
    {},
    () => {
      closePopupAcademic();
      window.location.reload();
    },
    (error) => {
      onError(error);
    }
  );

  const operations: TableOperation[] = [
    {
      name: "show",
      icon: FaEye,
      link: true,
      onClick: () => {
        console.log("View");
      },
    },
    {
      name: "edit",
      icon: RiEditBoxFill,
      link: false,
      onClick: (id: string | number) => {
        if (typeof id === "number") {
          setId(id);
          openEditPopupAcademic(id);
        }
      },
    },
    {
      name: "delete",
      icon: FaRegTrashAlt,
      link: true,
      onClick: (id) => {
        setPopUpDelete([id, true]);
      },
    },
  ];

  const toastId = useRef<string | number | null>(null);

  useEffect(() => {
    if (mutation.isLoading && !toast.isActive(toastId.current!)) {
      toastId.current = toast.loading("جاري التحميل...", {
        position: "bottom-left",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    } else if (!mutation.isLoading && toastId.current && !mutation.isError) {
      toast.update(toastId.current, {
        render: "تم التحميل بنجاح!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      toastId.current = null;
    } else if (mutation.isError) {
      toast.update(toastId.current!, {
        render: Id ? "هناك خطأ في عملية التعديل" : "هناك خطأ في عملية الاضافة",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      toastId.current = null;
    }
  }, [mutation.isLoading, mutation.isError]);

  return (
    <>
      <ToastContainer position="bottom-left" />
      <Row>
        <Col>
          <Title title="القوائم الامتحانية " />
        </Col>
      </Row>
      <Row>
        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <Selected
            name="semester_id"
            title="أختر اسم الفصل"
            text="أختر اسم الفصل"
            value={searchParams.get("semester_id")!}
            onChange={(e) => {
              if (e.target.value) {
                handleParamsClick("semester_id", e.target.value);
              } else {
                handleParamDelete("semester_id");
              }
            }}
            className="!w-[300px] max-lg:!w-full mb-5"
          >
            {semesters?.data?.data?.map((e: any) => (
              <option value={e.id}>{e.name}</option>
            ))}
          </Selected>
        </Col>

        <Col
          lg={6}
          md={6}
          sm={6}
          className="flex items-center justify-center !mb-0"
        >
          <Selected
            title="أختر اسم المقرر"
            name="curriculum_id"
            text="أختر اسم المقرر"
            value={searchParams.get("curriculum_id")!}
            onChange={(e) => {
              if (e.target.value) {
                handleParamsClick("curriculum_id", e.target.value);
              } else {
                handleParamDelete("curriculum_id");
              }
            }}
            className="!w-[300px] max-lg:!w-full mb-5"
          >
            {curriculums?.data?.data?.map((e: any) => (
              <option value={e.id}>{e.name_ar}</option>
            ))}
          </Selected>
        </Col>
      </Row>

      {/* <Row justify={"around"}>
        <Col lg={4}>
          <div>
            <h1 className="font-bold text-base ">نسبة النجاح : 40%</h1>
          </div>
        </Col>
        <Col lg={4}>
          <div>
            <h1 className="font-bold text-base ">نسبة الرسوب : 60%</h1>
          </div>
        </Col>
      </Row> */}
      {isLoading && <Loader />}
      <Row justify="center">
        <Table<Exam>
          tableHeads={[" الرقم  ", " العلامة", " العلامة المكتوبة", "العمليات"]}
          tableBody={data?.data?.studentMarks?.data}
          keys={["id", "mark", "written_mark"]}
          operations={operations}
          className="lg:min-w-[100px] md:min-w-[50px]"
        />
      </Row>
      {data?.data?.data?.length > 0 && (
        <Pagination pageCount={data?.data?.last_page} />
      )}
      <PopUpDelete
        text="هل أنت متأكد من حذف هذا الفصل؟"
        onClickDelete={() =>
          deleteItem(`admin/student-marks/${popUpDelete[0]}`)
        }
      />

      <div
        className={`flex z-10 justify-center  items-center fixed  bottom-10 left-5 font-bold text-5xl bg-Secondary text-white cursor-pointer w-14 h-14 rounded-full`}
        onClick={() => setPopup(2)}
      >
        <span className="mb-3">+</span>
      </div>

        {Popup === 2 && (
          <Row>
            <Col
              lg={12}
              className="h-[100vh]  w-full flex  z-50 justify-center items-center fixed top-0 right-0 font-bold  !bg-black !bg-opacity-50  "
            >
              {EditLoading ? (
                <Loader />
              ) : (
                <Row
                  justify={"around"}
                  className="relative w-[47%] max-lg:w-[80%] max-md:w-full h-[80%] overflow-y-scroll bg-white p-5 border-2 rounded-xl "
                >
                  <div
                    className="absolute   cursor-pointer hover:text-white text-Secondary hover:transition-all flex items-center justify-start   "
                    onClick={closePopupAcademic}
                  >
                    <span className="hover:bg-red-600 bg-gray-100 absolute px-3 py-1 text-2xl flex justify-center items-center rounded-full ">
                      X
                    </span>
                  </div>

                  <Col lg={12} className="flex justify-center !mt-2">
                    <Title title="قم بادخال معلومات المقررات" />
                  </Col>

                  <>
                    <Col lg={5} className=" ">
                      <Selected
                        text=" رقم الطالب "
                        title=" رقم الطالب "
                        name="student_id"
                        onChange={(e) =>
                          handleChangeSelect({
                            value: e.currentTarget.value,
                            label: e.currentTarget.name,
                          })
                        }
                        defaultValue={Id != null ? Edit?.data?.student?.id : ""}
                      >
                        {student?.data?.data?.map((e: any) => (
                          <option value={e.id}>
                            {e.first_name_ar}
                            {e.last_name_ar}
                          </option>
                        ))}

                        {errors?.student_id &&
                          errors?.student_id.map((error, index) => (
                            <p
                              key={index}
                              className="text-red-600 text-sm"
                              dir="auto"
                            >
                              {error}
                            </p>
                          ))}
                      </Selected>
                    </Col>

                    <Col lg={5} className=" ">
                      <Selected
                        text=" رقم الفصل "
                        title=" رقم الفصل "
                        name="semester_id"
                        onChange={(e) =>
                          handleChangeSelect({
                            value: e.currentTarget.value,
                            label: e.currentTarget.name,
                          })
                        }
                        defaultValue={Id != null ? Edit?.data?.semester_id : ""}
                      >
                        {semesters?.data?.data?.map((e: any) => (
                          <option value={e.id}>{e.name}</option>
                        ))}
                      </Selected>
                      {errors?.semester_id &&
                        errors?.semester_id.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <Selected
                        text="  المقرر "
                        title=" المقرر "
                        name="curriculum_id"
                        onChange={(e) =>
                          handleChangeSelect({
                            value: e.currentTarget.value,
                            label: e.currentTarget.name,
                          })
                        }
                        defaultValue={Id != null ? Edit?.data?.curriculum_id : ""}
                      >
                        {curriculums?.data?.data?.map((e: any) => (
                          <option value={e.id}>{e.name_ar}</option>
                        ))}
                      </Selected>
                      {errors?.curriculum_id &&
                        errors?.curriculum_id.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>

                    <Col lg={5} className=" ">
                      <Input
                        type="text"
                        name="written_mark"
                        onChange={handleChangeInput}
                        title=" العلامة كتابتا "
                        placeholder=" العلامة كتابتا "
                        className="!w-full"
                        defaultValue={Id != null ? Edit?.data?.written_mark : ""}
                      />
                      {errors?.written_mark &&
                        errors?.written_mark.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5} className=" ">
                      <Input
                        type="number"
                        name="mark"
                        onChange={handleChangeInput}
                        title=" العلامة  "
                        placeholder=" العلامة  "
                        className="!w-full"
                        defaultValue={Id != null ? Edit?.data?.mark : ""}
                      />
                      {errors?.mark &&
                        errors?.mark.map((error, index) => (
                          <p
                            key={index}
                            className="text-red-600 text-sm"
                            dir="auto"
                          >
                            {error}
                          </p>
                        ))}
                    </Col>
                    <Col lg={5}></Col>
                  </>

                  <Col lg={5} sm={6} className="!mt-3 ">
                    <MainButton
                      titlebtn={Id ? "تعديل" : "إنشاء"}
                      className="!w-full "
                      onClick={() =>
                        handleSubmit(
                          Id
                            ? `admin/student-marks/${Id}?_method=PUT`
                            : `admin/student-marks`
                        )
                      }
                    />
                  </Col>
                  <Col
                    lg={5}
                    sm={6}
                    className="!mt-3 "
                    onClick={closePopupAcademic}
                  >
                    <MainButton
                      titlebtn="الغاء"
                      className="!w-full !bg-white border border-Secondary !text-Secondary hover:!bg-Secondary hover:!text-white"
                    />
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        )}
    </>
  );
};

export default Exam_Lists;
